<template>
  <div v-if="userinfo!=null">
    <van-cell-group>
      <van-cell center title="开启通知" label="开启后允许微信发送推送消息">
        <template slot="right-icon" >
          <van-switch :value="is_msg" size="24"  @input="onInput"></van-switch>
        </template>
      </van-cell>
      <van-cell title="头像" is-link >
        <div slot="default">
          <van-image style="height: 24px;width: 24px" round scale-down lazy-load :src="userinfo.avatar"></van-image>
        </div>
      </van-cell>
      <van-cell title="昵称" is-link :value="userinfo.nickname"></van-cell>
      <van-cell title="手机号"  :value="userinfo.phone"></van-cell>
    </van-cell-group>
    <div style="padding: 0 30px;margin-top: 30px"><van-button  type="danger" block @click="logout">退出登录</van-button></div>
  </div>
</template>
<script>
    import ic_vip from '@/assets/ic_vip.png'
    import ic_buyed from '@/assets/ic_buyed.png'
    import ic_dingyue from '@/assets/ic_dingyue.png'
    import default_head from '@/assets/default_head.png'
    export default {
        props: ['id'],
        name:'userinfo',
        data() {
            return {
                is_msg:false,
                images:{
                    ic_vip:ic_vip,
                    ic_buyed:ic_buyed,
                    ic_dingyue:ic_dingyue,
                    default_head:default_head
                },
                userinfo:null
            }
        },
        created(){
        },
        mounted() {
            // this.getUserInfo();
            this.userinfo = this.westore.state.user.userInfo;
            this.is_msg = this.userinfo.is_msg===1;
        },
        methods:{
            logout:function () {
                this.westore.commit('setToken','');
                this.eventbus.$emit(this.weconfig.event.loginChanged, false);
                window.history.back();
            },
            getUserInfo:function(){
                let that = this;
                this.westore.dispatch('getUserInfo').then(user => {
                    console.log(user)
                    this.userInfo = user;
                    this.is_msg = user.is_msg===1;
                }).catch((res) => {
                    that.westore.commit('setToken', '')
                })
            },
            onInput:function(checked){
                this.is_msg  = checked;
                this.switch_push(this.is_msg)
            },
            switch_push:function(checked){
                let that = this;
                this.weapi.request({
                    url: 'switch_push',
                    method: 'post',
                    params: {is_msg:checked},
                }).then(res => {
                    if (res.data.code === '200') {
                        this.getUserInfo();
                    }
                    else {
                        that.$toast(res.data.message);
                    }
                }).catch(function (error) {
                    that.$toast('系统错误，请稍后重试！');
                }).finally(function (response) {
                })
            },
        }
    }
</script>
<style>
  .mine-head{
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
  }
  .mine-head-content{
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: flex-start;
    margin: 10px;
  }
  .mine-head-content .item{
    font-size: 14px;
    color: #888;
    margin: 2px;
  }
  .mine-head-content .nickname{
    font-size: 16px;
    color: #333;

  }
  .vip-wrap{
    font-size: 14px;
    padding: 10px 16px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
  .vip-wrap-title{
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
  }
  .vip-wrap-title span{
    margin: 0 15px 0 5px;
  }
  .vip-wrap-title .endtime{
    color: #888;
  }
</style>
